export default [
  {
    key: 'assignedOperatorId',
    label: 'field.operator',
    rules: 'required',
    type: 'async-single-selection',
    repository: 'employee',
    selectionKey: 'id',
    selectionLabel: 'name',
    clearable: false,
    cols: 12,
  },
]
